import React from 'react';

const WebsiteDeactive = () => {
    return (
        <svg width={17} height={20} viewBox="0 0 17 20">
            <g transform="translate(0 -2)">
                <path
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                />
                <circle
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    cx={4}
                    cy={4}
                    r={4}
                    transform="translate(4.5 3)"
                />
            </g>
        </svg>
    );
};

export default WebsiteDeactive;
